import { WardEntity } from '../entities';
import { WardPayloadForm } from '../ports/payloads';
import { WardRepository } from '../ports/repositories';

export class UpdateWardUsecase {
  constructor(private readonly repo: WardRepository) {}

  async run(payload: WardPayloadForm): Promise<WardEntity> {
    const data = this.repo.updateWard(payload);
    return data;
  }
}
